export enum ACTIVITY_EVENT_TYPE {
  IMPORT = 'IMPORT',
  RSM_FILE_PROCESSED = 'RSM_FILE_PROCESSED',
  THERAPY_RESULT = 'THERAPY_RESULT',
  BULK_ATTENDANCE = 'BULK_ATTENDANCE',
  IMPERSONATE = 'IMPERSONATE',
  PERSON_ARCHIVE = 'PERSON_ARCHIVE',
  PERSON_CREATE = 'PERSON_CREATE',
  PERSON_INFORMATION_CHANGE = 'PERSON_INFORMATION_CHANGE',
  PERSON_UNARCHIVE = 'PERSON_UNARCHIVE',
}

export enum ACTIVITY_LOG_IMPORT {
  EVENT = 'IMPORT',
  LABEL = 'imported',
  SUCCESS = 'with no errors',
  FAILURE = 'with some errors',
}
